/**
 * TimelineRowLines Component
 *
 * Renders horizontal grid lines for crop rows.
 * Creates visual separation between crop rows.
 */

import React from 'react'
import { useTimelineStaticContext } from '../../context/timeline-static-context'
import { useTimelineStyles } from '../../../hooks/use-timeline-styles'
import {
  EXPANDED_ROW_HEIGHT,
  VERTICAL_DAY_TRACKER_SPACE,
} from '../../timeline-constants'

/**
 * TimelineRowLines - Horizontal grid lines
 *
 * @param {Object} props
 * @param {Array} props.crops - Transformed crop data
 */
export const TimelineRowLines = React.memo(({ crops }) => {
  const { TIMELINE_WIDTH, expandedIds, getRowY, forceAllExpand, viewStrategy, collapsedRowHeight } = useTimelineStaticContext()
  const { ROW_SEPARATOR_COLOR } = useTimelineStyles()

  return (
    <>
      {crops.map((crop) => {
        const isExpanded = forceAllExpand || expandedIds.includes(crop.id)
        const rowY = getRowY(crop.id) + VERTICAL_DAY_TRACKER_SPACE * 8

        // Calculate row height: double when showing both phases and tasks
        const baseRowH = isExpanded ? EXPANDED_ROW_HEIGHT : collapsedRowHeight
        const rowH = viewStrategy === 'both' && !crop.isOrgTaskRow ? baseRowH * 2 : baseRowH

        return (
          <g key={crop.id}>
            {/* Top line */}
            <line
              x1={0}
              y1={rowY}
              x2={TIMELINE_WIDTH}
              y2={rowY}
              stroke={ROW_SEPARATOR_COLOR}
              strokeWidth={1}
            />
            {/* Bottom line */}
            <line
              x1={0}
              y1={rowY + rowH}
              x2={TIMELINE_WIDTH}
              y2={rowY + rowH}
              stroke={ROW_SEPARATOR_COLOR}
              strokeWidth={1}
            />
          </g>
        )
      })}
    </>
  )
})
